<template>
  <div id="app">
    <router-view/>
    <!-- <Waimai/> -->
    <!-- <TabBar></TabBar> -->
    <div class="icp_box">
      <a href="https://beian.miit.gov.cn" class="icp">浙ICP备17034232号-2</a>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/tabBar'
export default {
  name: 'App',
  components:{
    TabBar,
  }
}
</script>

<style>

html,body {
  color: #333;
  margin: 0;
  height: 100%;
  font-family: "Myriad Set Pro","Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: normal;
  font-size: 13px;
  background: #EBEBEB;
  color: #333;
}

#app {
  height: 100%;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.icp_box {
  text-align: center;
  margin-top: 200px;
}
.icp {
  text-align: center;
  text-decoration: none;
  color: #999;
}
a:active {
  background-color: #999;
}
a:visited {
  background-color: #999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue